import React from "react";
import { Avatar, ListItemText, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import { useSelector } from "react-redux";
import { IReduxState } from "../../store";
import { SITEWEB_SERVER_BASE_URL } from "../../util/apiClient";
import MenuApp from "./MenuApp";



const Liste = () => {

  //Redux
  const { filteredAgents, fonctions, services } = useSelector((state: IReduxState) => state.siteWeb);

  //Obtenir la fonction d'un agent
  const getFonctionAgent = (idFonction: number) => {
    const fonctionAgent = fonctions.find(item => item.idFonction === idFonction)
    return fonctionAgent?.fonctionAgent
  }

  //Obtenir le service d'un agent
  const getServiceAgent = (idService: number) => {
    const serviceAgent = services.find(item => item.idService === idService)
    return serviceAgent?.libService
  }

  return (
    <div
      style={{
        padding: 10,
        height: "55vh",
        overflow: "auto",
      }}
    >
      <Box sx={{ flexGrow: 1, width: "100%" }}>
        <List dense={true}>
          {filteredAgents.map((item, i: number) => {
            return (
              <div key={i}>
                <ListItem
                  secondaryAction={
                    <MenuApp
                      item={item}
                    />
                  }
                >
                  <ListItem>
                    <ListItemIcon>
                      <Avatar alt="Pas d'image" src={`${SITEWEB_SERVER_BASE_URL}/equipeImages/${item?.photoAgent}`} />
                    </ListItemIcon>
                    <ListItemButton>
                      <ListItemText
                        primary={item.nomAgent}
                        secondary={
                          <Box style={{ display: "flex", flexDirection: "column" }}>
                            <Typography variant="caption">
                              {`Service: ${getServiceAgent(item.idService)}`}
                            </Typography>
                            <Typography variant="caption">
                              {`Fonction: ${getFonctionAgent(item.idFonction)}`}
                            </Typography>
                          </Box>
                        }
                      />
                    </ListItemButton>
                  </ListItem>
                </ListItem>
                <Divider />
              </div>
            );
          })}
        </List>
      </Box>
    </div>
  );
};
export default Liste;
